import styled from "styled-components";

export const EventGridWrapper = styled.div`
  display: grid;
  justify-content: center;
`;
